import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { LoadingWidget } from '../../../../../widgets';
import { PARAMS_DOCENTES } from '../../../../control_estudios/docentes/DocentesReducer';
import {
  allDocentesAction,
  oneDocentesAction,
} from '../../../docentes/DocentesAction';
import SelectFieldDocentesComponent from '../../../docentes/components/SelectFieldDocentes';
import { allMateriasAction } from '../../../materias/MateriasAction';
import { PARAMS_MATERIAS } from '../../../materias/MateriasReducer';
import SelectFieldMateriasComponent from '../../../materias/components/SelectFieldMaterias';
import { allSeccionesAction } from '../../../secciones/SeccionesAction';
import { PARAMS_SECCIONES } from '../../../secciones/SeccionesReducer';
import SelectFieldSeccionesComponent from '../../../secciones/components/SelectFieldSecciones';
import { allPlanEvaluacionAction } from '../PlanEvaluacionAction';
import { PARAMS_PLAN_EVALUACION } from '../PlanEvaluacionReducer';

const FiltrosPlanEvaluacionComponent = ({ setDocenteSelect = () => {} }) => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const docentesStore = Redux.useSelector((state) => state.docentes);
  const materiasStore = Redux.useSelector((state) => state.materias);
  const seccionesStore = Redux.useSelector((state) => state.secciones);

  const [materias, setMaterias] = React.useState([]);
  const [secciones, setSecciones] = React.useState([]);
  const [loadingGetDocente, setLoadingGetDocente] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      const payload = { idEntidad: entidadesStore.activo.id };

      if (docentesStore.all && docentesStore.all.length === 0) {
        dispatch({ type: PARAMS_DOCENTES, payload });
        await allDocentesAction(dispatch, payload);
      }

      if (materiasStore.all && materiasStore.all.length === 0) {
        dispatch({ type: PARAMS_MATERIAS, payload });
        await allMateriasAction(dispatch, payload);
      }

      if (seccionesStore.all && seccionesStore.all.length === 0) {
        dispatch({ type: PARAMS_SECCIONES, payload });
        await allSeccionesAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    async function fecthData() {
      if (!loginStore.isAdminTeacher && planEvaluacionStore.params.idDocente) {
        setLoadingGetDocente(true);
        const res = await oneDocentesAction(
          dispatch,
          planEvaluacionStore.params.idDocente,
        );
        setDocenteSelect(res);
        setLoadingGetDocente(false);

        const listSecciones = [];
        res.secciones.forEach((el) => listSecciones.push(el.seccion));
        setSecciones(listSecciones);

        const listMaterias = [];
        res.materias.forEach((el) => listMaterias.push(el.materia));
        setMaterias(listMaterias);
      }
    }

    fecthData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planEvaluacionStore.params.idDocente]);

  React.useEffect(() => {
    if (!planEvaluacionStore.params.idMateria) {
      setMaterias(materiasStore.all);
    }

    if (!planEvaluacionStore.params.idSeccion) {
      setSecciones(seccionesStore.all);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planEvaluacionStore.params]);

  const getData = async (payload) => {
    dispatch({
      type: PARAMS_PLAN_EVALUACION,
      payload,
    });
    await allPlanEvaluacionAction(dispatch, payload);
  };

  return (
    <Grid container spacing={2}>
      <Grid item md={12}>
        <Typography variant="h6" color="initial">
          FILTROS
        </Typography>
      </Grid>

      {(loginStore.isAdmin || loginStore.isRoot) && (
        <Grid item md={12}>
          {loadingGetDocente && (
            <LoadingWidget pb={1} isLoading={loadingGetDocente} />
          )}
          <SelectFieldDocentesComponent
            value={planEvaluacionStore.params.idDocente}
            isEmpty={false}
            onChange={async (idDocente) => {
              await oneDocentesAction(dispatch, idDocente);
              getData({
                ...planEvaluacionStore.params,
                idDocente,
              });
            }}
          />
        </Grid>
      )}
      <Grid item md={12}>
        <SelectFieldMateriasComponent
          value={planEvaluacionStore.params.idMateria}
          onChange={(idMateria) =>
            getData({
              ...planEvaluacionStore.params,
              idMateria,
            })
          }
          data={loginStore.isAdminTeacher ? materiasStore.all : materias}
        />
      </Grid>
      <Grid item md={12}>
        <SelectFieldSeccionesComponent
          value={planEvaluacionStore.params.idSeccion}
          onChange={(idSeccion) =>
            getData({
              ...planEvaluacionStore.params,
              idSeccion,
            })
          }
          data={loginStore.isAdminTeacher ? seccionesStore.all : secciones}
        />
      </Grid>
    </Grid>
  );
};

export default FiltrosPlanEvaluacionComponent;
